import { MarketingChannel } from 'eve-account-client';

export type MarketingFormData = {
  marketingQuestionPrimary: string;
  marketingQuestionSecondary?: string;
};

export type MouPageFormData = {
  mouSignatory: string;
  infoIsCorrect?: boolean;
  agreedToTerms?: boolean;
} & MarketingFormData;

export enum MouRoutes {
  BASE = '/account/enroll/client/mou',
  SIGN = '/account/enroll/client/mou/sign/:code',
  ACCEPT = '/account/enroll/client/mou/accept',
  REJECT = '/account/enroll/client/mou/reject',
}

export const marketingChannelData: Array<MarketingChannel> = [
  {
    value: 175,
    code: 'EVERIFY_REPERESENTATIVE',
    displayName: 'E-Verify representative (webinar, presentation, etc.)',
    textEntry: false,
    displayOrder: 10,
    parentValue: 170,
  },
  {
    value: 168,
    code: 'GOVERNMENT_REQUIREMENT',
    displayName: 'Due to a Government Requirement',
    textEntry: false,
    displayOrder: 10,
    parentValue: undefined,
  },
  {
    value: 172,
    code: 'FEDERAL_CONTRACT_REQUIREMENT',
    displayName: 'Federal contract or Requirement',
    textEntry: false,
    displayOrder: 10,
    parentValue: 168,
  },
  {
    value: 181,
    code: 'USED_PRIOR_EMPLOYER',
    displayName: 'Used at a prior employer',
    textEntry: false,
    displayOrder: 10,
    parentValue: 171,
  },
  {
    value: 176,
    code: 'PROFESSIONAL_ASSOCIATION',
    displayName: 'Professional association/organization',
    textEntry: false,
    displayOrder: 20,
    parentValue: 170,
  },
  {
    value: 169,
    code: 'I9_REMOTE_INSPECTION',
    displayName: 'To participate in Form I-9 Remote Document Examination',
    textEntry: false,
    displayOrder: 20,
    parentValue: undefined,
  },
  {
    value: 173,
    code: 'STATE_REQUIREMENT',
    displayName: 'State requirement',
    textEntry: false,
    displayOrder: 20,
    parentValue: 168,
  },
  {
    value: 182,
    code: 'WWW_EVERIFY_GOV',
    displayName: 'www.E-Verify.gov',
    textEntry: false,
    displayOrder: 20,
    parentValue: 171,
  },
  {
    value: 183,
    code: 'WWW_EVERIFY_I9CENTRAL',
    displayName: 'www.uscis.gov/I-9Central',
    textEntry: false,
    displayOrder: 30,
    parentValue: 171,
  },
  {
    value: 170,
    code: 'RECOMMENDATION',
    displayName: 'It was recommended to me',
    textEntry: false,
    displayOrder: 30,
    parentValue: undefined,
  },
  {
    value: 174,
    code: 'LOCAL_REQUIREMENT',
    displayName: 'Local requirement',
    textEntry: false,
    displayOrder: 30,
    parentValue: 168,
  },
  {
    value: 177,
    code: 'EXISTING_EVERIFY_USER',
    displayName: 'Existing E-Verify user',
    textEntry: false,
    displayOrder: 30,
    parentValue: 170,
  },
  {
    value: 178,
    code: 'HUMAN_RESOURCE_VENDOR',
    displayName: 'Human resource vendor',
    textEntry: false,
    displayOrder: 40,
    parentValue: 170,
  },
  {
    value: 171,
    code: 'OWN_INITIATIVE',
    displayName: 'My own initiative',
    textEntry: false,
    displayOrder: 40,
    parentValue: undefined,
  },
  {
    value: 184,
    code: 'FOUND_YOUTUBE',
    displayName: 'Found on YouTube',
    textEntry: false,
    displayOrder: 40,
    parentValue: 171,
  },
  {
    value: 179,
    code: 'OTHER_GOVERNMENT_AGENCY',
    displayName: 'Other government agency',
    textEntry: false,
    displayOrder: 50,
    parentValue: 170,
  },
  {
    value: 185,
    code: 'FOUND_SOCIAL_MEDIA',
    displayName: 'Found on social media',
    textEntry: false,
    displayOrder: 50,
    parentValue: 171,
  },
  {
    value: 186,
    code: 'FOUND_BUSINESS_TOOLKIT',
    displayName: 'Found in business startup toolkit',
    textEntry: false,
    displayOrder: 60,
    parentValue: 171,
  },
  {
    value: 180,
    code: 'MY_COMPANY_LEADERSHIP',
    displayName: 'My company/organization leadership',
    textEntry: false,
    displayOrder: 60,
    parentValue: 170,
  },
  {
    value: 187,
    code: 'GENERAL_INTERNET_SEARCH',
    displayName: 'General internet search',
    textEntry: false,
    displayOrder: 70,
    parentValue: 171,
  },
];

export default marketingChannelData;
